import React from 'react';
import { Box, HintPlacement, Inscription, LockIcon, SimpleHint } from '@common-fe/common-fe';

export const ORGANIZATION_LOCK_TOOLTIP_TEXT =
  'This account is locked. Payments and account orders will not be processed.';

interface Props {
  testId?: string;
}

const OrganizationLockIcon: React.FC<Props> = ({ testId = 'organization-lock' }) => (
  <SimpleHint
    preferAlign={HintPlacement.TOP}
    isFixed
    usePortal
    width="247px"
    round="container1Round"
    testId={testId}
    content={
      <Box data-testid={`${testId}_tooltip`}>
        <Inscription size="small" weight={500} color="textOnColor" textAlign="center" lineHeight="18px">
          {ORGANIZATION_LOCK_TOOLTIP_TEXT}
        </Inscription>
      </Box>
    }
  >
    <Box flex={false} justify="center" data-testid={`${testId}_icon`}>
      <LockIcon color="iconSecondary" />
    </Box>
  </SimpleHint>
);

export default OrganizationLockIcon;
